import request from './request'

export function listOtherIn(data) {
  return request.post('/inventory/other-ins/list', data)
}
export function getOtherIn(id) {
  return request.get('/inventory/other-ins/' + id)
}
export function saveOtherIn(data) {
  return request.post('/inventory/other-ins', data)
}
export function updateOtherIn(data) {
  return request.post('/inventory/other-ins/update', data)
}
export function deleteOtherIn(ids) {
  return request.post('/inventory/other-ins/delete', ids)
}
export function approveOtherIn(stockInId) {
  return request.post('/inventory/other-ins/approve', { stockInId })
}
export function unapproveOtherIn(stockInId) {
  return request.post('/inventory/other-ins/unapprove', { stockInId })
}
